import { render, staticRenderFns } from "./MdtTransition.vue?vue&type=template&id=f1cf6014&scoped=true"
import script from "./MdtTransition.vue?vue&type=script&lang=js"
export * from "./MdtTransition.vue?vue&type=script&lang=js"
import style0 from "./MdtTransition.vue?vue&type=style&index=0&id=f1cf6014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cf6014",
  null
  
)

export default component.exports